<template>
  <form action>
    <label for="email">Email</label>
    <input type="email" name="email" v-model="form.email" />
    <label for="password">password</label>
    <input type="password" name="password" v-model="form.password" />
    <button type="submit" @click.prevent="login">Entrar</button>
  </form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    async login() {
      await this.$store.dispatch("LOGIN", this.form);
      this.$router.replace("/admin/services/new");
    }
  }
};
</script>

<style>
</style>